import { useContext } from 'react';
import { WholesaleApiContext } from '~/components/providers/WholesaleApiProvider';

export const useWholesaleApiContext = () => {
  const context = useContext(WholesaleApiContext);

  return context;
};
